<template>
    <modal-live :default-show-modal="false">
        <div class="dialog">
            <div class="text-center">
                <img
                    :src="assetUrl('images/illustrations/welcome.svg')"
                    alt="Hammer - Online Tool for Truckers"
                    width="367"
                    height="148"
                />
            </div>
            <h2
                class="headline--welcome text-center"
                style="margin-top: 16px; margin-bottom: 16px"
            >
                Hammer - Online Tool for Truckers
            </h2>
            <div class="d-flex justify-content-center">
                <ul class="list__features">
                    <li>
                        <svg>
                            <use :xlink:href="`${icons['map']}#icon`"></use>
                        </svg>
                        Map for Professional Truckers
                    </li>
                    <li>
                        <svg>
                            <use
                                :xlink:href="`${icons['shipping']}#icon`"
                            ></use>
                        </svg>
                        Truck Specific Routing
                    </li>
                    <li>
                        <svg>
                            <use :xlink:href="`${icons['gas']}#icon`"></use>
                        </svg>
                        POIs with diesel prices
                    </li>
                </ul>
            </div>
            <div class="text-center pt-3">
                <Button @click.native="goTo('profile')" class="text-sm">
                    Create driver profile
                </Button>
            </div>
            <div class="text-center">
                <Bullets :step="step" :steps="steps"></Bullets>
            </div>
        </div>
    </modal-live>
</template>

<script>
export default {
    data() {
        return {
            icons: window.here.icons,
            step: 0,
            steps: 5,
            welcomeCompleted: window.config.welcome_completed,
        };
    },
    methods: {
        goTo(name) {
            this.$router.push({ name });
        },
    },
    mounted() {
    },
};
</script>

<style lang="scss">
.dialog {
    padding: 24px;
}

.list__features {
    margin: 0;
    padding: 0;
    list-style-type: none;
    font-size: 20px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0.13px;
    color: #4e3a30;

    li {
        padding: 8px 0;
    }

    svg {
        width: 20px;
        height: 20px;
        margin-right: 12px;
    }
}
</style>
